import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Card, Empty, Row, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";

import { LessonDemand } from "../../../utils";
import { formatTimeAgo } from "../../../utils/helpers";
import { useDispatch, useSelector } from "react-redux";
import { newsFeedTypes } from "../../../redux/learner/actions";
import { selectLearnerNewsFeed } from "../../../redux/learner/selector";

const cloudfrontKey = process.env.REACT_APP_CLOUDFRONT_KEY;
const { Text } = Typography;

const LatestLessonDemands = ({
  lessonDemands,
  getLessonDemand,
  lessonDemandsLoaded,
}: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const newsFeed = useSelector(selectLearnerNewsFeed);

  useEffect(() => {
    dispatch({ type: newsFeedTypes.GET_LEARNER_NEWS_FEED_ACTION });
    if (lessonDemandsLoaded) return;
    getLessonDemand();
  }, []);

  return (
    <div className="pb-6">
      <div className="flex flex-row items-center justify-between">
        <Text className="text-neutral-600 font-semibold text-lg">
          Lesson Demands
        </Text>
      </div>
      <Row gutter={[16, 16]} className="mt-4">
        <Card className="w-full p-6 educator-dashboard-box-shadow-cards">
          {lessonDemands?.length > 0 ? (
            <>
              <Text className="text-neutral-600 font-semibold text-xs block mb-4">
                Total: {lessonDemands?.length}
                {newsFeed?.lessonDemands! > 0 &&
                  ` (${newsFeed?.lessonDemands} new demands)`}
              </Text>
              <div className="grid grid-cols-3 gap-6">
                {(lessonDemands.length > 3
                  ? lessonDemands?.slice(
                      lessonDemands?.length - 3,
                      lessonDemands?.length
                    )
                  : lessonDemands
                ).map((demand: LessonDemand) => (
                  <Card
                    key={demand?.id}
                    id={demand?.id}
                    className={`border-none bg-neutral-100 cursor-pointer`}
                    onClick={() =>
                      navigate("/educator/lesson-demand", {
                        state: { lessonDemandId: demand?.id },
                      })
                    }
                  >
                    <div className="flex flex-col gap-4 p-4 pb-1">
                      <div className="flex gap-2">
                        <div>
                          {!demand?.createdUser?.profilePictureKey ? (
                            <Avatar size={40} icon={<UserOutlined />} />
                          ) : (
                            <Avatar
                              size={40}
                              src={`${cloudfrontKey}/${demand?.createdUser?.profilePictureKey}`}
                            />
                          )}
                        </div>
                        <div className="flex flex-col justify-between">
                          <Text className="text-base leading-[18px] font-semibold text-neutral-600 break-words">
                            {demand?.createdUser?.name ??
                              demand?.createdUser?.email}
                          </Text>
                          <div className="text-sm leading-4 text-neutral-500">
                            {formatTimeAgo(demand?.createdAt)}
                          </div>
                        </div>
                      </div>

                      <Text className="text-sm text-neutral-600 font-semibold break-words h-10 overflow-auto pt-0">
                        {demand?.title}
                      </Text>
                    </div>
                  </Card>
                ))}
              </div>
            </>
          ) : (
            <Empty className="py-5" image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </Card>
      </Row>
    </div>
  );
};

export default LatestLessonDemands;
